
import {
  schema, normalize
} from 'normalizr'

import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'

// Define answer schema
const iframesSchema = new schema.Entity('iframes')
const iframesListSchema = [iframesSchema]

export function adaptIFramesToStore({ data }) {
  const entries = normalize(data.results, iframesListSchema)
  return {
    entries: entries.entities.iframes,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptIFrameToApi(iframe = {}) {
  let payload = {
    ...iframe
  }
  delete payload.duration_in_seconds
  payload = omitBy(payload, isNil)

  return payload
}

export function adaptIFrameToStore({ data }) {
  return {
    ...data
  }
}